import { Button, Size } from "@clockwise/design-system/src/components/Button";
import classNames from "classnames";
import React from "react";

import { Kbd } from "@clockwise/design-system";
import { AlternateEmail } from "@material-ui/icons";

type Props = {
  onClickEmailShortcut: () => void;
  onClickSubmit: () => void;
  size: "small" | "large";
  buttonSize: Size;
};

export const ChatInputFooter = ({
  onClickEmailShortcut,
  onClickSubmit,
  size,
  buttonSize,
}: Props) => {
  return (
    <div
      className={classNames("cw-flex cw-justify-between cw-pb-2 cw-pl-2", {
        "cw-pr-2": size === "small",
        "cw-pr-4 cw-pt-2": size === "large",
      })}
    >
      <Button
        variant={size === "small" ? "text" : "outlined"}
        sentiment="neutral"
        size={buttonSize}
        onClick={onClickEmailShortcut}
      >
        <AlternateEmail className="cw-text-subtle cw-w-3 cw-h-3" />
      </Button>
      <Button variant="solid" sentiment="positive" size={buttonSize} onClick={onClickSubmit}>
        Get proposal&nbsp;
        <Kbd size="xs" className="cw-leading-3">
          ⏎
        </Kbd>
      </Button>
    </div>
  );
};
